Ext.define('SA.VectorMapThematicMapGeoJsonSourcesData', {
    singleton: true,

    get(modelState, {enableServerSideClustering}) {
        var businesses = SA.VectorMapBusinessPointsGeoJsonSourceData.get(modelState, {enableServerSideClustering}),
            highlight = SA.VectorMapLocationHighlightGeoJsonSourceData.get(modelState),
            info = SA.VectorMapInfoLocationHighlightGeoJsonSourceData.get(modelState),
            mask = SA.VectorMapLocationMaskGeoJsonSourceData.get(modelState),
            radius = SA.VectorMapRadiusGeoJsonSourceData.get(modelState);

        return {businesses, highlight, info, mask, radius};
    }
});